import watchNewControlePragaDoenca from './saga/new';
import watchFindControlePragaDoenca from './saga/find';
import watchCreateControlePragaDoenca from './saga/create';
import watchListAllControlePragaDoenca from './saga/listAll';
import watchListControlePragaDoenca from './saga/listTable';
import watchDeleteControlePragaDoenca from './saga/delete';
import watchNewFilterControlePragaDoenca from './saga/newFilter';
import watchNewFilterNextPageControlePragaDoenca from './saga/newFilterNextPage';
import watchMarcarTratadoControlePragaDoenca from './saga/marcarTratado';
import watchMarcarCanceladoControlePragaDoenca from './saga/marcarCancelado';

export const controlePragaDoencaSaga = [
    watchNewControlePragaDoenca(),
    watchFindControlePragaDoenca(),
    watchCreateControlePragaDoenca(),
    watchListAllControlePragaDoenca(),
    watchListControlePragaDoenca(),
    watchDeleteControlePragaDoenca(),
    watchNewFilterControlePragaDoenca(),
    watchNewFilterNextPageControlePragaDoenca(),
    watchMarcarTratadoControlePragaDoenca(),
    watchMarcarCanceladoControlePragaDoenca(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
